import LearnPageLayout from "@/components/LearnPageLayout";
import { page6 } from "./learnDataP6";

const TreatmentResistantDepressionPage = () => (
  <LearnPageLayout
    title={page6.title}
    description={page6.description}
    canonical={page6.canonical}
    h1={page6.h1}
    breadcrumbLabel={page6.breadcrumbLabel}
    crumbs={page6.crumbs}
    shortAnswer={page6.shortAnswer}
    keyTakeaways={page6.keyTakeaways}
    sections={page6.sections}
    faqs={page6.faqs}
    sources={page6.sources}
    schemaJson={page6.schemaJson}
    relatedLinks={page6.relatedLinks}
    reviewBlock={page6.reviewBlock}
    toc={page6.toc}
    safetyBlock={page6.safetyBlock}
    trademarkFooter={page6.trademarkFooter}
    ctaBand={page6.ctaBand}
  />
);

export default TreatmentResistantDepressionPage;
